/*
 * RUM Core Web Vitals -> GA4.
 * Capture les métriques terrain (vrais visiteurs) via la lib officielle web-vitals
 * (assets/web-vitals.iife.js) et les envoie en events GA4 par la queue gtag.
 *
 * Chargé en `defer` APRÈS web-vitals.iife.js (les scripts defer s'exécutent dans
 * l'ordre) : window.webVitals est donc disponible. gtag() est le stub inline posé
 * par nc-consent-mode/nc-ga4 : les events s'empilent dans dataLayer et sont rejoués
 * au chargement différé de gtag.js (1er geste ou load+4s). Le Consent Mode gère la
 * confidentialité (analytics_storage denied => pings cookieless, pas de PII).
 *
 * Reporting GA4 : chaque métrique = un event nommé LCP/INP/CLS/FCP/TTFB avec
 * value (entier ; CLS ×1000), metric_id, metric_rating, metric_value, metric_delta,
 * navigation_type. Pour exploiter metric_rating/metric_value en rapports, déclarer
 * les dimensions/métriques personnalisées correspondantes dans GA4.
 */
(function () {
  'use strict';
  var wv = window.webVitals;
  if (!wv || typeof window.gtag !== 'function') return;

  function send(metric) {
    window.gtag('event', metric.name, {
      // GA4 attend un entier ; CLS est un ratio < 1 -> ×1000 pour rester lisible.
      value: Math.round(metric.name === 'CLS' ? metric.delta * 1000 : metric.delta),
      metric_id: metric.id,
      metric_value: metric.value,
      metric_delta: metric.delta,
      metric_rating: metric.rating, // 'good' | 'needs-improvement' | 'poor'
      navigation_type: metric.navigationType,
      // Télémétrie perf : ne pas compter comme interaction (engagement/rebond).
      non_interaction: true,
    });
  }

  // reportAllChanges: false (défaut) -> une valeur finalisée par métrique et par page.
  wv.onLCP(send);
  wv.onINP(send);
  wv.onCLS(send);
  wv.onFCP(send);
  wv.onTTFB(send);
})();
